import React from 'react';

export default () => (
  <svg viewBox="0 0 1118 802.82">
    <defs>
      <linearGradient
        id="a"
        x1="882.02"
        y1="830.64"
        x2="882.02"
        y2="326.6"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stopColor="gray" stopOpacity=".25" />
        <stop offset=".54" stopColor="gray" stopOpacity=".12" />
        <stop offset="1" stopColor="gray" stopOpacity=".1" />
      </linearGradient>
    </defs>
    <ellipse cx="559" cy="734.87" rx="559" ry="67.95" fill="#674f91" opacity=".1" />
    <path
      d="M956.49 768.18s29.15-37.1 26.79-73.91a71.52 71.52 0 0 1 11.25-43.8 121.69 121.69 0 0 1 13.7-17.2"
      fill="none"
      stroke="#535461"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M1006.89 610.07c-2.06 5.15 1.31 23.81 1.31 23.81s15.29-11.21 17.34-16.37a10.04 10.04 0 1 0-18.65-7.44z"
      fill="#674f91"
    />
    <path
      d="M980.08 632.46c1.07 5.44 14 19.27 14 19.27s6.74-17.72 5.67-23.17a10.046 10.046 0 0 0-19.71 3.9z"
      fill="#674f91"
    />
    <path
      d="M961.29 681.49c3.68 4.16 21.86 9.55 21.86 9.55s-3.13-18.7-6.81-22.86a10.046 10.046 0 0 0-15.05 13.31z"
      fill="#674f91"
    />
    <path
      d="M955.44 721.79c2.92 4.72 19.92 13.11 19.92 13.11s.08-19-2.84-23.68a10.043 10.043 0 0 0-17.08 10.57z"
      fill="#674f91"
    />
    <path
      d="M1013.31 660.55c-5.13 2.11-23.83-1-23.83-1s11-15.42 16.17-17.53a10.044 10.044 0 1 1 7.66 18.57z"
      fill="#674f91"
    />
    <path
      d="M1005.86 707.59c-5.52.49-22.42-8.11-22.42-8.11s15.14-11.41 20.67-11.9a10.038 10.038 0 0 1 1.75 20z"
      fill="#674f91"
    />
    <path
      d="M992.35 752.33c-5.37 1.41-23.48-4.21-23.48-4.21s13-13.81 18.37-15.22a10.045 10.045 0 1 1 5.11 19.43z"
      fill="#674f91"
    />
    <path
      d="M1006.89 610.07c-2.06 5.15 1.31 23.81 1.31 23.81s15.29-11.21 17.34-16.37a10.04 10.04 0 1 0-18.65-7.44z"
      opacity=".25"
    />
    <path
      d="M980.08 632.46c1.07 5.44 14 19.27 14 19.27s6.74-17.72 5.67-23.17a10.046 10.046 0 0 0-19.71 3.9z"
      opacity=".25"
    />
    <path
      d="M961.29 681.49c3.68 4.16 21.86 9.55 21.86 9.55s-3.13-18.7-6.81-22.86a10.046 10.046 0 0 0-15.05 13.31z"
      opacity=".25"
    />
    <path
      d="M955.44 721.79c2.92 4.72 19.92 13.11 19.92 13.11s.08-19-2.84-23.68a10.043 10.043 0 0 0-17.08 10.57z"
      opacity=".25"
    />
    <path
      d="M1013.31 660.55c-5.13 2.11-23.83-1-23.83-1s11-15.42 16.17-17.53a10.044 10.044 0 1 1 7.66 18.57z"
      opacity=".25"
    />
    <path
      d="M1005.86 707.59c-5.52.49-22.42-8.11-22.42-8.11s15.14-11.41 20.67-11.9a10.038 10.038 0 0 1 1.75 20z"
      opacity=".25"
    />
    <path
      d="M992.35 752.33c-5.37 1.41-23.48-4.21-23.48-4.21s13-13.81 18.37-15.22a10.045 10.045 0 1 1 5.11 19.43z"
      opacity=".25"
    />
    <path
      d="M956.73 766.63s41.69-22.1 54.45-56.7a71.54 71.54 0 0 1 28-35.49 120.33 120.33 0 0 1 19.5-10.17"
      fill="none"
      stroke="#535461"
      strokeMiterlimit="10"
      strokeWidth="2"
    />
    <path
      d="M1066.88 642.51c-4 3.88-8.45 22.3-8.45 22.3s18.52-4.06 22.49-7.93a10.031 10.031 0 0 0-14-14.37z"
      fill="#674f91"
    />
    <path
      d="M1033.3 652.11c-1.22 5.41 5 23.32 5 23.32s13.34-13.48 14.56-18.89a10.042 10.042 0 0 0-19.59-4.43z"
      fill="#674f91"
    />
    <path
      d="M996.26 689.33c1.67 5.29 16.11 17.59 16.11 17.59s4.71-18.37 3-23.66a10.044 10.044 0 1 0-19.15 6.07z"
      fill="#674f91"
    />
    <path
      d="M974.57 723.8c.76 5.5 12.91 20.06 12.91 20.06s7.75-17.31 7-22.8a10.044 10.044 0 1 0-19.9 2.74z"
      fill="#674f91"
    />
    <path
      d="M1052.3 691.26c-5.55-.14-21.37-10.6-21.37-10.6s16.35-9.62 21.89-9.48a10.043 10.043 0 1 1-.52 20.08z"
      fill="#674f91"
    />
    <path
      d="M1026.43 731.25c-5.25-1.79-17.22-16.5-17.22-16.5s18.47-4.3 23.72-2.5a10.04 10.04 0 1 1-6.5 19z"
      fill="#674f91"
    />
    <path
      d="M995.94 766.67c-5.47-.88-19.75-13.36-19.75-13.36s17.48-7.35 23-6.47a10.043 10.043 0 1 1-3.2 19.83z"
      fill="#674f91"
    />
    <path
      d="M637.14 95.08c-55.24-1.92-107.85-19.75-158.08-39.26s-100-41.13-153.92-51.41c-34.67-6.65-74.33-7.59-102.27 11C196 33.25 187.3 64.13 182.63 92.79c-3.52 21.56-5.59 44.25 4 64.43 6.69 14 18.56 25.8 26.77 39.22 28.56 46.7 8.37 104.29-22.58 149.9-14.52 21.39-31.36 41.79-42.57 64.57s-16.38 48.86-6.58 72.09c9.72 23 32.87 40.32 57.95 52.48 50.94 24.71 111 31.78 169.51 35.78 129.58 8.87 259.85 5 389.77 1.18 48.09-1.42 96.38-2.86 143.68-10.29 26.27-4.13 53.39-10.69 72.45-26.51 24.21-20.08 30.21-54.09 14-79.27-27.21-42.24-102.44-52.73-121.46-98.06-10.46-24.95.29-52.74 15.5-75.88 32.63-49.65 87.33-93.2 90.22-149.94 2-39-24.32-78-65-96.44-42.62-19.32-101.72-16.89-133.16 15.1-32.32 32.95-89.22 45.62-137.99 43.93z"
      fill="#674f91"
      opacity=".1"
    />
    <path
      d="M593 316.53h-24.87a53.14 53.14 0 0 1 .36-5.74c.78-6.78 3.18-17.78 10.62-22.94 6.95-4.82 16 2.45 12.45 10.14l-.09.21c-1.33 2.78-1.37 6.24-.93 9.41a39.4 39.4 0 0 0 2.46 8.92z"
      fill="#674f91"
    />
    <path
      d="M593 316.53h-24.87a53.14 53.14 0 0 1 .36-5.74 52.06 52.06 0 0 1 22-3.18 39.4 39.4 0 0 0 2.51 8.92z"
      opacity=".1"
    />
    <path
      d="M609.13 342.86c-6.45 5.25-15.47 5.33-24.7 3.08-18.9-4.62-38.63-19.08-38.63-19.08a44.12 44.12 0 0 1 4.32-4.18c7.78-6.68 25.61-18.49 49.48-12.62a24.44 24.44 0 0 1 14.45 9.66c3.95 5.78 6.01 14.25-4.92 23.14z"
      fill="#674f91"
    />
    <path d="M601.53 332.33s-14.38-12.25-34.19 4" opacity=".1" />
    <path
      d="M197.14 435.53s-46.34-35.66-48.67-3.33 9.33 62.67 19.33 65.33 29.34-62 29.34-62z"
      fill="#674f91"
    />
    <path
      d="M197.14 435.53s-46.34-35.66-48.67-3.33 9.33 62.67 19.33 65.33 29.34-62 29.34-62z"
      opacity=".2"
    />
    <path d="M166.8 446.87s1.09 29.75 10.34 25-4.34-23.67-10.34-25z" opacity=".1" />
    <path
      d="M311 689.06a54.35 54.35 0 0 1-5 13.15c-.57 1.08-1.19 2.19-1.87 3.32C293.22 723.67 268 731.2 268 727.2s-2.49-14.34-8.83-11.34-16 2.34-16 2.34c-17.45-1.33-14.5-18.53-8.72-33.1a134.21 134.21 0 0 1 6.58-14c2.18-4 3.81-6.62 3.81-6.62l66.67 10.67s1.49 5.26-.51 13.91z"
      fill="#674f91"
    />
    <path
      d="M584.43 345.94c-18.9-4.62-38.63-19.08-38.63-19.08a44.12 44.12 0 0 1 4.32-4.18q4.32 2.28 8.68 4.85a165 165 0 0 1 25.63 18.41z"
      opacity=".1"
    />
    <path
      d="M311 689.06c-18.09-1.62-44.29-6.07-70-17.91 2.18-4 3.81-6.62 3.81-6.62l66.67 10.67s1.52 5.21-.48 13.86z"
      opacity=".1"
    />
    <path
      d="M591.8 602.53s-1.2 21.37-13.26 45.52a115.43 115.43 0 0 1-41.41 46.48s-10.66 8.67-11.33-15.33c0 0-4.67-5-36.67 16.85 0 0-19.31 11.8-14-37.43v-.09c0-.03-.48.31-1.36.84h-.06c-2.28 1.4-7.12 4.27-12.88 7.16-10.55 5.3-24.22 10.69-31 7.29a102 102 0 0 1-11.34 35.59c-6.72 12.23-17.32 24.19-33.92 29.59a23.85 23.85 0 0 1-24.2-5.9l-1.9-1.9s-14.67 10-22 6.66-13.34-12.66-3.34-30c0 0 .53-1.44 1.18-3.55 1.63-5.35 4-15 .16-16.45 0 0-155.34 8-176-130s116-188.66 154.66-183.33c0 0 102.67-129.33 244.67-46s34 274 34 274z"
      fill="#674f91"
    />
    <path
      d="M313.13 374.53s169.22-.66 157.61 218.67"
      fill="none"
      stroke="#000"
      strokeMiterlimit="10"
      opacity=".1"
    />
    <path
      d="M306 702.21c-.57 1.08-1.19 2.19-1.87 3.32C293.22 723.67 268 731.2 268 727.2s-2.49-14.34-8.83-11.34-16 2.34-16 2.34c-17.45-1.33-14.5-18.53-8.72-33.1 16.36 8.21 45.95 20.44 71.55 17.11z"
      opacity=".2"
    />
    <path
      d="M418.49 709.41c-6.72 12.23-17.32 24.19-33.92 29.59a23.85 23.85 0 0 1-24.2-5.9l-1.9-1.9s-14.67 10-22 6.66-13.34-12.66-3.34-30c0 0 .53-1.44 1.18-3.55 13.07 4.61 47.69 14.42 84.18 5.1z"
      opacity=".2"
    />
    <path d="M475.13 658.53c60.33-31.33 70.67-56.33 70.67-56.33" opacity=".1" />
    <path
      d="M578.54 648.05a115.43 115.43 0 0 1-41.41 46.48s-10.66 8.67-11.33-15.33c0 0-4.67-5-36.67 16.85 0 0-19.31 11.8-14-37.43l16-8.87c34.48 19.17 69.12 7.48 87.41-1.7z"
      opacity=".2"
    />
    <path
      d="M331.14 393.87s34-52 59.66-35.67-4.66 77.33-4.66 77.33-50.34-1-55-41.66z"
      fill="#674f91"
    />
    <path
      d="M331.14 393.87s34-52 59.66-35.67-4.66 77.33-4.66 77.33-50.34-1-55-41.66z"
      opacity=".2"
    />
    <path d="M386.47 379.53s-44.67 21.67-31 34.34 31-34.34 31-34.34z" opacity=".1" />
    <path
      d="M504.8 320.86a185.62 185.62 0 0 0-33.75 6l-.31.09c-15.64 4.35-33.4 11.67-45.61 23.88 0 0-28.33-12-36-10 0 0 23-27.95 84.85-28.66h.15s16 1.36 30.67 8.69z"
      fill="none"
    />
    <ellipse
      cx="308.19"
      cy="588.78"
      rx="62.39"
      ry="51.67"
      transform="rotate(-13 74.502 744.47)"
      opacity=".1"
    />
    <ellipse
      cx="308.19"
      cy="586.78"
      rx="62.39"
      ry="51.67"
      transform="rotate(-13 74.507 742.47)"
      fill="#674f91"
    />
    <ellipse
      cx="308.19"
      cy="586.78"
      rx="62.39"
      ry="51.67"
      transform="rotate(-13 74.507 742.47)"
      opacity=".2"
    />
    <path d="M240.8 538.19s.67 19.34 6.34 13.68.33-13.7-6.34-13.68z" opacity=".1" />
    <path d="M273.14 523.47s.66 19.34 6.33 13.68.33-13.74-6.33-13.68z" opacity=".1" />
    <path d="M327.86 634.2s13.94 13.67 30.94-5.33" opacity=".1" />
    <path
      d="M389.13 340.86c7.67-2 36 10 36 10 12.21-12.21 30-19.53 45.61-23.88L474 312.2c-61.91.71-84.87 28.66-84.87 28.66z"
      opacity=".15"
    />
    <path
      d="M474.13 312.2l-3.08 14.69a185.62 185.62 0 0 1 33.75-6c-14.67-7.36-30.67-8.69-30.67-8.69z"
      opacity=".3"
    />
    <path d="M474 312.2l-3.24 14.78.31-.09 3.08-14.69z" opacity=".15" />
    <g opacity=".1" fill="#fff">
      <path d="M340.13 714.12s.53-1.44 1.18-3.55c1.63-5.35 4-15 .16-16.45 0 0-1.78.09-5 .08a49.55 49.55 0 0 1-2.17 10.37c-.65 2.11-1.18 3.55-1.18 3.55-10 17.34-4 26.67 3.34 30l.39.14c-2.95-5.05-3.19-12.92 3.28-24.14z" />
      <path d="M165.47 564.12c-20.67-138 120.4-194.08 159.06-188.71l-11.4-.58c-38.66-5.33-175.33 45.33-154.66 183.33 6.5 43.39 26.32 72.34 50.43 91.65-20.9-19.2-37.57-46.58-43.43-85.69z" />
      <path d="M482.12 664.88v-.09c0-.03-.48.31-1.36.84h-.06c-1.35.82-3.6 2.17-6.4 3.73-1 22.75 4.89 27.68 9.52 28.11-2.35-5.31-3.58-15.06-1.7-32.59z" />
      <path d="M532.8 685.46s-1.2-1.27-6.5.3c1.38 9.92 5.2 11 7.92 10.41a42 42 0 0 1-1.42-10.71z" />
    </g>
    <path d="M334.47 687.86s86.67-5.33 95.33-14" opacity=".1" />
    <ellipse cx="542.56" cy="664.53" rx="37.56" ry="39.87" fill="#fbd56f" />
    <ellipse cx="542.56" cy="664.53" rx="37.56" ry="39.87" opacity=".1" />
    <ellipse cx="549.04" cy="665.42" rx="37.56" ry="38.98" fill="#fbd56f" />
    <path
      d="M564.26 700.74l-3.91-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.66a2.68 2.68 0 0 0 1.56-2.17c.37-3.34-.91-10.23-1.42-11.57-1.07-2.89-78.28 2.17-78.28 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M564.26 700.74l-3.91-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.66a2.68 2.68 0 0 0 1.56-2.17c.37-3.34-.91-10.23-1.42-11.57-1.07-2.89-78.28 2.17-78.28 2.17z"
      opacity=".1"
    />
    <ellipse cx="601.46" cy="698.57" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M580 687.07l-3.9-2.17s-1.83 7.62-1.23 13.06a2.69 2.69 0 0 0 2 2.33c9 2.24 51.82 11.75 81.28-1.65a2.7 2.7 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.11-2.89-78.28 2.17-78.28 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M580 687.07l-3.9-2.17s-1.83 7.62-1.23 13.06a2.69 2.69 0 0 0 2 2.33c9 2.24 51.82 11.75 81.28-1.65a2.7 2.7 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.11-2.89-78.28 2.17-78.28 2.17z"
      opacity=".1"
    />
    <ellipse cx="617.16" cy="684.9" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M593.85 669.1l-3.91-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.83 11.74 81.28-1.66a2.71 2.71 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.57-1.07-2.89-78.28 2.17-78.28 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M593.85 669.1l-3.91-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.83 11.74 81.28-1.66a2.71 2.71 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.57-1.07-2.89-78.28 2.17-78.28 2.17z"
      opacity=".1"
    />
    <ellipse cx="631.05" cy="666.93" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M578.47 650.41l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.58-1.06-2.9-78.27 2.18-78.27 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M578.47 650.41l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.58-1.06-2.9-78.27 2.18-78.27 2.18z"
      opacity=".1"
    />
    <ellipse cx="615.67" cy="648.22" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M613.06 635.41l-3.9-2.18s-1.83 7.63-1.23 13.06a2.7 2.7 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.72 2.72 0 0 0 1.57-2.17c.36-3.34-.92-10.24-1.43-11.58-1.07-2.91-78.28 2.18-78.28 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M613.06 635.41l-3.9-2.18s-1.83 7.63-1.23 13.06a2.7 2.7 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.72 2.72 0 0 0 1.57-2.17c.36-3.34-.92-10.24-1.43-11.58-1.07-2.91-78.28 2.18-78.28 2.18z"
      opacity=".1"
    />
    <ellipse cx="650.26" cy="633.21" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M589.69 625.3l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.24-1.43-11.58-1.06-2.89-78.27 2.18-78.27 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M589.69 625.3l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.24-1.43-11.58-1.06-2.89-78.27 2.18-78.27 2.18z"
      opacity=".1"
    />
    <ellipse cx="626.89" cy="623.12" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M605.29 605.82l-3.9-2.18s-1.83 7.63-1.23 13.06a2.7 2.7 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.65a2.69 2.69 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.58-1.06-2.89-78.28 2.18-78.28 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M605.29 605.82l-3.9-2.18s-1.83 7.63-1.23 13.06a2.7 2.7 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.65a2.69 2.69 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.58-1.06-2.89-78.28 2.18-78.28 2.18z"
      opacity=".1"
    />
    <ellipse cx="642.5" cy="603.64" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M613 582.7l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.58-1.07-2.89-78.27 2.18-78.27 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M613 582.7l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.58-1.07-2.89-78.27 2.18-78.27 2.18z"
      opacity=".1"
    />
    <ellipse cx="650.19" cy="580.52" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M682.39 706.11l-3.91-2.18s-1.83 7.63-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.65a2.71 2.71 0 0 0 1.56-2.18c.37-3.34-.91-10.23-1.42-11.57-1.07-2.89-78.28 2.18-78.28 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M682.39 706.11l-3.91-2.18s-1.83 7.63-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.65a2.71 2.71 0 0 0 1.56-2.18c.37-3.34-.91-10.23-1.42-11.57-1.07-2.89-78.28 2.18-78.28 2.18z"
      opacity=".1"
    />
    <ellipse cx="719.59" cy="703.93" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M696.27 688.14l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.24-1.43-11.58-1.06-2.89-78.27 2.18-78.27 2.18z"
      fill="#fbd56f"
    />
    <path
      d="M696.27 688.14l-3.91-2.18s-1.82 7.63-1.23 13.06a2.72 2.72 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.65a2.7 2.7 0 0 0 1.57-2.17c.36-3.34-.92-10.24-1.43-11.58-1.06-2.89-78.27 2.18-78.27 2.18z"
      opacity=".1"
    />
    <ellipse cx="733.47" cy="685.96" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M680.89 669.41l-3.9-2.17s-1.83 7.62-1.23 13.06a2.69 2.69 0 0 0 2 2.33c9 2.24 51.82 11.75 81.28-1.65a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.83-78.28 2.17-78.28 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M680.89 669.41l-3.9-2.17s-1.83 7.62-1.23 13.06a2.69 2.69 0 0 0 2 2.33c9 2.24 51.82 11.75 81.28-1.65a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.83-78.28 2.17-78.28 2.17z"
      opacity=".1"
    />
    <ellipse cx="718.1" cy="667.26" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M715.49 654.41l-3.91-2.17s-1.83 7.62-1.23 13a2.7 2.7 0 0 0 2 2.34c9 2.24 51.82 11.74 81.28-1.65a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.91-10.23-1.42-11.57-1.07-2.78-78.28 2.22-78.28 2.22z"
      fill="#fbd56f"
    />
    <path
      d="M715.49 654.41l-3.91-2.17s-1.83 7.62-1.23 13a2.7 2.7 0 0 0 2 2.34c9 2.24 51.82 11.74 81.28-1.65a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.91-10.23-1.42-11.57-1.07-2.78-78.28 2.22-78.28 2.22z"
      opacity=".1"
    />
    <ellipse cx="752.69" cy="652.25" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M692.11 644.33l-3.9-2.17s-1.83 7.62-1.23 13.06a2.7 2.7 0 0 0 2 2.33c9 2.24 51.82 11.74 81.28-1.65a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.89-78.28 2.17-78.28 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M692.11 644.33l-3.9-2.17s-1.83 7.62-1.23 13.06a2.7 2.7 0 0 0 2 2.33c9 2.24 51.82 11.74 81.28-1.65a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.89-78.28 2.17-78.28 2.17z"
      opacity=".1"
    />
    <ellipse cx="729.32" cy="642.16" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M707.72 624.85l-3.91-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.66a2.71 2.71 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.89-78.27 2.17-78.27 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M707.72 624.85l-3.91-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.27-1.66a2.71 2.71 0 0 0 1.57-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.89-78.27 2.17-78.27 2.17z"
      opacity=".1"
    />
    <ellipse cx="744.92" cy="622.68" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M715.41 601.73l-3.9-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.66a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.89-78.28 2.17-78.28 2.17z"
      fill="#fbd56f"
    />
    <path
      d="M715.41 601.73l-3.9-2.17s-1.83 7.62-1.23 13.06a2.71 2.71 0 0 0 2 2.34c9 2.23 51.82 11.74 81.28-1.66a2.68 2.68 0 0 0 1.56-2.17c.36-3.34-.92-10.23-1.43-11.57-1.06-2.89-78.28 2.17-78.28 2.17z"
      opacity=".1"
    />
    <ellipse cx="752.62" cy="599.56" rx="41.11" ry="9.27" fill="#fbd56f" />
    <path
      d="M408.6 314.41c0-21.52 16.81-39 37.56-39a36.83 36.83 0 0 1 6.07.51 35.52 35.52 0 0 0-12.56-2.29c-20.74 0-37.55 17.85-37.55 39.87 0 16.54 9.49 30.72 23 36.76.65-.57 1.46-1.25 2.42-2a39.24 39.24 0 0 1-18.94-33.85z"
      fill="#fbd56f"
    />
    <path
      d="M408.6 314.41c0-21.52 16.81-39 37.56-39a36.83 36.83 0 0 1 6.07.51 35.52 35.52 0 0 0-12.56-2.29c-20.74 0-37.55 17.85-37.55 39.87 0 16.54 9.49 30.72 23 36.76.65-.57 1.46-1.25 2.42-2a39.24 39.24 0 0 1-18.94-33.85z"
      opacity=".1"
    />
    <path
      d="M477.23 313.56a42.19 42.19 0 0 1-2 12.81c2.28-.55 4.66-1 7.11-1.52a40.47 40.47 0 0 0 1.37-10.44c0-19.38-13.63-35.44-31.48-38.46 14.57 5.52 25 20.26 25 37.61z"
      fill="#fbd56f"
    />
    <path
      d="M408.6 314.41a39.24 39.24 0 0 0 18.95 33.86c7.07-5.62 22.66-15.95 47.69-21.93a42.19 42.19 0 0 0 2-12.81c0-17.35-10.43-32.09-25-37.58a36.83 36.83 0 0 0-6.07-.51c-20.76.03-37.57 17.48-37.57 38.97z"
      fill="#fbd56f"
    />
    <path
      d="M1004.19 809.23c-5.72-.2-5.93-2.42-13.28-6.25-4.16-2.16-10.46-8.44-15.16-13.49l-1.1-1.19h2s-1.84-16.13-.2-20 .41-26.62.41-26.62 1-17.35-.82-21.38.61-29.84.61-29.84 1.64-15.33 2-46.59-18-32.26-18-32.26-2.45-.19-6.17-.55l-1.12-.11c2.41-5 3.82-8.82 3.82-8.82s-3.07-29.24-3.89-34.28-5.71-25.85-5.71-25.85-3.47-8.87-5.52-15.12-8.17-13.51-8.17-13.51-11-21.78-14.1-25c-1.42-1.49-3.42-3.38-5.15-5l-.9-.82a36 36 0 0 0 .74-6.9s-11.45-11.3-12.27-14.12-11.64-13.31-11.64-13.31-6.14-11.29-13.08-11.49a56.65 56.65 0 0 0-9.85.29c1.43-5.28 3.12-10.81 4.63-15.56.17-.53.34-1 .5-1.55a35.06 35.06 0 0 0 12.56-15.19c.14-.33.27-.66.4-1h.22a6.11 6.11 0 0 0 .86-.08c2.29-.39 4.23-3 3.17-5a.76.76 0 0 0 .67.37c.76 0 1.69-1.13 1.87-2.1 0-.17.05-.34.07-.51s.07-.42.1-.63 0-.4 0-.6v-.61-.58-.67-.53c0-.18 0-.54-.06-.81v-.33a18 18 0 0 0-.66-3.25c-1.12-3.75-3.49-7.47-2.58-11.27V377c.76-3 3.32-5.1 4.88-7.74.15-.25.28-.51.41-.77 0-.05.05-.1.07-.14.1-.2.18-.4.26-.6l.16-.39c.07-.17.12-.35.18-.53s.11-.32.15-.49.08-.32.12-.48.09-.38.13-.58 0-.28.07-.42.06-.44.08-.66 0-.24 0-.36v-1.04-.82-.24c0-.29 0-.58-.08-.87v-.12a14.49 14.49 0 0 0-2.93-6.95 17.91 17.91 0 0 0-14.71-6.37 24.62 24.62 0 0 1-4.62.09c-2.57-.38-4.74-2-6.78-3.58l-17.12-13.19a21.28 21.28 0 0 0-6.47-3.84c-2.42-.74-5.32-.49-7.11 1.28-3.21 3.16-1.17 8.6-2.45 12.89-1.12 3.72-4.71 6.24-8.42 7.49s-7.69 1.53-11.51 2.44a6.29 6.29 0 0 0-3.07 1.41 6 6 0 0 0-1.34 4.29 23.06 23.06 0 0 0 2.66 10.91c.72 1.36 1.59 2.75 2.36 4.15l.19.35.25.48c.13.27.26.53.38.79l.15.34.23.57c0 .12.09.24.13.35s.14.45.21.67a7.42 7.42 0 0 1 .11 4c-.59 2.17-2.28 3.84-3.78 5.53a10.87 10.87 0 0 0-2.52 4.68 3.52 3.52 0 0 0 0 1.24v.15a2.76 2.76 0 0 0 .08.27 1.54 1.54 0 0 0 .08.19 2 2 0 0 0 .1.21 1.87 1.87 0 0 0 .26.3l.15.11a1.64 1.64 0 0 0 .26.16l.17.08.42.11h.12a4.66 4.66 0 0 0 .66 0h.2a5 5 0 0 0 .62-.08h.23a8.7 8.7 0 0 0 1-.25 21.13 21.13 0 0 0 3.34-1.32v1.01a33.94 33.94 0 0 0 2.21 11.57 35 35 0 0 0 10.65 14.73c-.06.34-.12.69-.19 1.05-1 4.83-3.05 9.68-4.32 9.31a17.07 17.07 0 0 0-3.79-.42h-1.11a15.41 15.41 0 0 0-3.48 0 3.66 3.66 0 0 1-1.52-.21 20.68 20.68 0 0 0-10.21-.57c-7.06 1.45-17.81 4.1-20.76 7.27-4.5 4.84-11 9.48-18.39 29.64 0 0-3.68 12.3-6.54 13.92a19.25 19.25 0 0 1 1.94-.88 5.22 5.22 0 0 1-1.53 1.68 22.66 22.66 0 0 1 3.21-1.34c-2.23 13.14 1.08 50.72 1.08 50.72s-2.66 6.48.81 10.32c2.07 2.27 3.19 5.82 3.77 8.34l-.51.78c-1.84 2.85-4.3 6.57-5.91 8.62-2.86 3.63-2.05 15.13-2.05 15.13s-.61 5.44-2.65 7.46-1.64 9.48-1.64 9.48L751.19 608s-4.91 4.43-4.91 6.45-3.88 7.66-3.88 7.66-5.93 9.68 0 8.27a18.53 18.53 0 0 0 6-3v1.23c-.17 10.54 1 25.38 8.76 25.38 12 0 43.12 14.31 43.12 14.31 6.33 4.84 14.91 3.23 14.91 3.23s-15.19 15.09-14.75 21.35-8.58 16.53-8.58 16.53l-27.8 54.25a41.39 41.39 0 0 0 2 11.12l-.4.34c-10.68 9.76-11.61 29.07-11.61 29.07l-2.45 9.88 37.19 16.34s48.23 1 56.61-1.21 6.54-11.5-4.5-13.31-13.69-6.66-17.37-8.87c-2.48-1.5-11.29-11.17-16.76-17.3-.08-.1-.16-.18-.24-.27l1.27-7c2.45-1.21 6.13-13.31 6.13-13.31s0-4.84 2.45-6.25 7.56-15.93 7.56-15.93 11-18.35 10.43-20.77 8-14.72 8-14.72 14.51-14.12 13.89-16.64 11.65-15.43 11.65-15.43a40.83 40.83 0 0 0 10.85-12.49l3.54-.58c16.05-2.63 42.71-7.38 45.69-8.71 4.09-1.81 3.27 6.26 1.64 13.11s-2.86 39.73-1 44 1 11.1 1 11.1l-2.45 36.9 1.63 7.87s-5.52 4.43-3.27 7.05.21 13.92.21 13.92c.19-.07.42-.14.67-.21-.19.44-.38.9-.55 1.37-3.17 9-1.35 23.84-1.35 23.84v11.7s56.61 1 69.07 1 29.64-6.05 30.66-10.89-14.34-8.94-20.06-9.15zm-161-209.93l-3.7.31a29.15 29.15 0 0 1 3.69-.31zm22.61-154.79c.52-2.34 1.15-4.84 1.85-7.42zm7 160.44a15 15 0 0 1-11 0s.2-14.11 1.84-20 3.88-16.54 3.88-16.54 1.84-14.72 3.68-21.38 9-43.76 12.67-46.18 5.72 1.82 5.72 1.82.55 0 1.47-.11c.18.38.37.8.59 1.23 4.36 8.81 17.15 26.91 17.15 26.91a29.43 29.43 0 0 1 9.4 9.28c3.48 5.84 4.5 19.56 4.5 19.56s7.77 30.45 11.44 34.68c1.84 2.12 1 3.38-.25 4.11a18.1 18.1 0 0 0-6.45 6c-.52.83-1.08 1.74-1.64 2.72-1.41-.33-2.66-.67-3.71-1-10.09-3.39-43.79-3.52-49.3-1.05z"
      transform="translate(-41 -48.59)"
      fill="url(#a)"
    />
    <path
      d="M882.15 768.02v11.6s55.39 1 67.59 1 29-6 30-10.8-14-8.8-19.6-9-5.8-2.4-13-6.2c-4.06-2.14-10.23-8.37-14.83-13.38-3.55-3.87-6.17-7-6.17-7s-29.79-.6-38.39 4.2c-2 1.1-3.35 3.27-4.28 6-3.1 8.9-1.32 23.58-1.32 23.58z"
      fill="#434175"
    />
    <path
      d="M883.47 744.41c6.25-2.17 42.82-3 48.84-3.14-3.55-3.87-6.17-7-6.17-7s-29.79-.6-38.39 4.2c-1.98 1.06-3.35 3.23-4.28 5.94z"
      opacity=".1"
    />
    <path
      d="M722.77 559.41l3.23 2 1.21.73 4.7 2.84c25.14 15.14 93.69 56.2 97.45 55.87 1-.08 3.94-.53 8-1.19l3.47-.57c15.7-2.61 41.79-7.32 44.71-8.64 4-1.8 3.2 6.2 1.6 13s-2.8 39.4-1 43.6 1 11 1 11l-2.4 36.6 1.6 7.8s-5.4 4.4-3.2 7 .2 13.8.2 13.8c6.4-2.4 49.79-3.2 49.79-3.2s-1.8-16-.2-19.8.4-26.4.4-26.4 1-17.2-.8-21.2.6-29.59.6-29.59 1.6-15.2 2-46.19-17.6-32-17.6-32-2.4-.19-6-.54c-7.13-.68-19-2-26.94-3.72a43.48 43.48 0 0 1-4.81-1.27c-9.8-3.34-42.8-3.47-48.19-1.07a14.52 14.52 0 0 1-10.78 0l-4.2-6.8-40.11 3.42-4.25.36-39.49 3.37-2.72.23z"
      fill="#565387"
    />
    <path
      d="M883.55 590.13c11.65 5.68 22.77-14.46 28-25.82-7.13-.68-19-2-26.94-3.72-5.27 8.76-12.23 24.09-1.06 29.54z"
      opacity=".1"
    />
    <path
      d="M848.55 454.06a12.55 12.55 0 0 0 1.41 3.92c4.27 8.73 16.79 26.68 16.79 26.68a29 29 0 0 1 9.2 9.2c3.4 5.8 4.4 19.4 4.4 19.4s7.6 30.19 11.2 34.39c1.8 2.1 1 3.35-.25 4.08a17.86 17.86 0 0 0-6.31 5.9c-5.25 8.44-13.62 25.16-1.84 30.9 16 7.8 31-33.08 31-33.08s-3-29-3.8-34-5.59-25.6-5.59-25.6-3.4-8.8-5.4-15-8-13.4-8-13.4-10.8-21.59-13.8-24.79c-1.39-1.49-3.34-3.36-5-4.94-2-1.83-3.56-3.26-3.56-3.26s-20.65 14.81-20.45 19.6z"
      fill="#ee8e9e"
    />
    <path
      d="M713 765.62l36.4 16.2s47.19 1 55.39-1.2 6.4-11.4-4.4-13.2-13.4-6.6-17-8.8c-2.43-1.48-11.05-11.07-16.4-17.15-2.58-2.93-4.4-5-4.4-5s-7-18.6-26.39-14.4a19.86 19.86 0 0 0-9.44 5c-10.45 9.67-11.36 28.82-11.36 28.82z"
      fill="#434175"
    />
    <path
      d="M727.21 562.13l4.7 2.84c25.14 15.14 93.69 56.2 97.45 55.87 1-.08 3.94-.53 8-1.19l3.47-.57.13-.23a45.32 45.32 0 0 0 4.58-11.21c4.21-15.99-16.54-28.23-16.54-28.23l-4.4-3.42c-5-8.42-41-16.38-41-16.38l-4.64-3.12-2.47-1.66-.66-.44-5.63-3.78-28.19 2-8.38 5.38-.88.57-3.11 2z"
      opacity=".1"
    />
    <path
      d="M726.73 727c7.65 26.47 39.63 17.83 39.63 17.83l.6-3.36c-2.58-2.93-4.4-5-4.4-5s-7-18.6-26.39-14.4a19.86 19.86 0 0 0-9.44 4.93z"
      opacity=".1"
    />
    <path
      d="M718.37 606.84c11.8 0 42.19 14.2 42.19 14.2 6.2 4.8 14.6 3.2 14.6 3.2s-14.8 15-14.4 21.2-8.39 16.4-8.39 16.4l-27.2 53.79c2 38.19 41.19 27.6 41.19 27.6l1.6-9c2.4-1.2 6-13.2 6-13.2s0-4.8 2.4-6.2 7.4-15.8 7.4-15.8 10.8-18.2 10.2-20.6 7.8-14.59 7.8-14.59 14.2-14 13.6-16.5 11.4-15.3 11.4-15.3a40.45 40.45 0 0 0 10.61-12.39 45.32 45.32 0 0 0 4.63-11.24c3.39-12.88-9.44-23.3-14.57-26.86-1.24-.87-2-1.33-2-1.33l-4.4-3.42c-2.27-3.83-11-7.57-19.76-10.5-6.34-2.11-12.74-3.81-16.83-4.83-2.78-.64-4.44-1.06-4.44-1.06l-4.64-3.12-1.63-1.09-1.49-1-5.68-3.79-12.54.89-15.65 1.11-8.37 5.42-4 2.58-15.63 10s-.41 3.85-.54 9v1.22c-.19 10.5.93 25.21 8.54 25.21z"
      fill="#565387"
    />
    <path
      d="M778.56 382.87l4.2 15s7.4 25.8 8.2 27.6 20.2 20 21 20.4 11.36 6.39 11.36 6.39.84-33 0-42.59a27.32 27.32 0 0 1 .52-6.29c1.27-7.52 4.5-18.55 7.18-27.05 2.24-7.11 4.09-12.45 4.09-12.45s-46.79-2-45.19 2.6c.6 1.74.41 4.64-.18 7.56-1 4.79-3 9.61-4.22 9.23a17 17 0 0 0-3.71-.41c-1.68-.05-3.25.01-3.25.01z"
      fill="#ee8e9e"
    />
    <path
      d="M789.78 374.04a34.61 34.61 0 0 0 41.28 2.29c2.24-7.11 4.09-12.45 4.09-12.45s-46.79-2-45.19 2.6c.6 1.74.41 4.64-.18 7.56z"
      opacity=".1"
    />
    <path
      d="M846.56 346.29a34.46 34.46 0 0 1-1.73 10.8 28.23 28.23 0 0 1-1 2.65 34.6 34.6 0 0 1-64.28-1.33 34.1 34.1 0 0 1-2.16-11.47v-.64a34.6 34.6 0 1 1 69.19 0z"
      fill="#ee8e9e"
    />
    <path
      d="M778.56 382.87l4.2 15s7.4 25.8 8.2 27.6 20.2 20 21 20.4 11.36 6.39 11.36 6.39.84-33 0-42.59a27.32 27.32 0 0 1 .52-6.29l-2.72 11.09.2 22.2 1.6 1.2-3.6 5.4v-4s-12.8-12.4-14.8-17.6-9.2-14.62-9.2-14.62-8.2-13.78-8.4-16.18c-.15-1.87-3.6-6.2-5.11-8-1.68-.06-3.25 0-3.25 0z"
      opacity=".1"
    />
    <path
      d="M848.55 454.06a12.55 12.55 0 0 0 1.41 3.92c4.38-.45 19.27-3.23 22.55-20.25-2-1.83-3.56-3.26-3.56-3.26s-20.6 14.8-20.4 19.59z"
      opacity=".1"
    />
    <path
      d="M709.8 581.68c4-2.86 7.88-6.75 10.17-7.83 3.4-1.6 8.6-6.8 8.6-6.8s1.32-.9 3.34-2.08c3.71-2.18 9.8-5.33 14.46-5.72 4.17-.35 18-1.24 29-1.92l14.24-.88s13-4.6 18.6-1.6a58.77 58.77 0 0 0 12.6 4.6v-1.19l-4.2-6.8-44.36 3.78-5.69-3.83-28.19 2-8.37 5.42-7.22.62 3.23 2-15.63 10s-.49 4.47-.58 10.23z"
      opacity=".1"
    />
    <path
      d="M704 583.41a18.11 18.11 0 0 0 5.86-3c4-2.85 7.85-6.74 10.14-7.81 3.4-1.6 8.6-6.8 8.6-6.8s10.6-7.2 17.8-7.8c2-.16 6.06-.45 11-.77s11-.71 16.32-1l8.48-.53 7.39-.46s13-4.6 18.6-1.6a58.77 58.77 0 0 0 12.6 4.6s.2-14 1.8-19.8 3.8-16.39 3.8-16.39 1.8-14.6 3.6-21.2 8.79-43.4 12.39-45.8 5.6 1.8 5.6 1.8 24-.4 24.4-26.79c0 0-11.2-11.2-12-14s-11.4-13.2-11.4-13.2-6-11.2-12.8-11.4a54.4 54.4 0 0 0-9.63.3l-5.76 23.5.2 22.2 1.6 1.2-3.6 5.4v-4s-12.8-12.4-14.8-17.6-9.2-14.62-9.2-14.62-8.2-13.78-8.4-16.18-5.8-8.83-5.8-8.83a14.72 14.72 0 0 0-3.4 0 3.53 3.53 0 0 1-1.49-.21 19.92 19.92 0 0 0-10-.56c-6.91 1.43-17.43 4.06-20.31 7.2-4.4 4.8-10.8 9.4-18 29.4l38.79 14-3.38 6.32-30.87 58.68s-1 1.67-2.41 3.85c-1.8 2.83-4.21 6.52-5.79 8.55-2.8 3.6-2 15-2 15s-.6 5.4-2.6 7.4-1.6 9.4-1.6 9.4l-5.2 19.4s-4.8 4.4-4.8 6.4-3.8 7.6-3.8 7.6-5.76 9.59.07 8.15z"
      fill="#434175"
    />
    <path d="M908.74 597.85s-12.59 4.19-16 10.19 16-10.19 16-10.19z" opacity=".1" />
    <path d="M902.35 584.65c-.4.6-17.26 17.51-16.2 21.59s16.2-21.59 16.2-21.59z" opacity=".1" />
    <path d="M809.76 596.65s-18.76 8.86-20.4 12.76 20.4-12.76 20.4-12.76z" opacity=".1" />
    <path d="M808.56 608.04s-17 7.2-19.28 9 19.28-9 19.28-9z" opacity=".1" />
    <path d="M800.76 623.41s-7.51 5.6-11.66 1.2 11.66-1.2 11.66-1.2z" opacity=".1" />
    <path d="M829 477.46c-.4.6-25.4 45.6-32 49s32-49 32-49z" opacity=".1" />
    <path d="M827.76 494.46c0 1-24.4 53.19-28.4 53.79s28.4-53.79 28.4-53.79z" opacity=".1" />
    <path d="M735 528.05s-11.78 25.17-16.4 26.6 16.4-26.6 16.4-26.6z" opacity=".1" />
    <path d="M733 516.86s-4.06 8.79-6.53 8.79 6.53-8.79 6.53-8.79z" opacity=".1" />
    <path
      d="M846.56 346.29a34.46 34.46 0 0 1-1.73 10.8 28.23 28.23 0 0 1-1 2.65 10.17 10.17 0 0 1-4.83-2.13 12 12 0 0 1-3.63-3.88 48.65 48.65 0 0 1-1.77-5.05 11.75 11.75 0 0 0-9.49-7.19c1.15 2-.68 4.65-2.93 5s-4.44-1-6-2.67-2.67-3.7-4.21-5.37-3.74-3-6-2.67c-2 .3-3.53 1.82-5.2 2.95s-4 1.89-5.6.68c-.9-.67-1.34-1.81-2.2-2.54-2.21-1.85-5.65.06-7.28 2.45-2.51 3.7-4 5.94-7.3 7.61v-.64a34.6 34.6 0 1 1 69.19 0z"
      opacity=".1"
    />
    <path
      d="M784.69 338.32c1.63-2.4 5.07-4.31 7.28-2.45.86.72 1.3 1.86 2.2 2.54 1.6 1.21 3.94.45 5.6-.68s3.21-2.65 5.2-2.95c2.25-.35 4.44 1 6 2.67s2.66 3.7 4.21 5.37 3.74 3 6 2.66 4.08-3 2.93-5a11.73 11.73 0 0 1 9.48 7.19 51.11 51.11 0 0 0 1.77 5.05 12 12 0 0 0 3.64 3.87c1.83 1.35 4.06 2.48 6.3 2.09s4.14-3 3.1-5c.71 1.09 2.25-.43 2.48-1.71a18.26 18.26 0 0 0-.46-8.44c-1.1-3.72-3.42-7.4-2.53-11.18.71-3 3.26-5.13 4.81-7.78 2.75-4.7 2-11-1.32-15.32a17.41 17.41 0 0 0-14.4-6.31 24.42 24.42 0 0 1-4.52.08c-2.51-.37-4.64-2-6.64-3.55l-16.77-13.06a20.56 20.56 0 0 0-6.33-3.82c-2.36-.73-5.2-.48-7 1.27-3.14 3.14-1.15 8.54-2.41 12.79-1.09 3.68-4.6 6.18-8.23 7.42s-7.52 1.52-11.26 2.42a6.16 6.16 0 0 0-3 1.4 6 6 0 0 0-1.31 4.26 23.11 23.11 0 0 0 2.6 10.81c1.94 3.73 5 7.56 3.93 11.63-.58 2.15-2.24 3.8-3.7 5.48-3.16 3.64-4.23 9 1.73 7.14 5.77-1.8 7.38-4.13 10.62-8.89z"
      fill="#434175"
    />
    <g opacity=".1">
      <path d="M850.87 348.06c-.24 1.28-1.77 2.8-2.49 1.71 1 2-.86 4.59-3.1 5s-4.46-.75-6.3-2.09a12 12 0 0 1-3.63-3.88c-.84-1.57-1.11-3.39-1.77-5.05a11.77 11.77 0 0 0-9.49-7.19c1.16 2-.68 4.66-2.93 5s-4.44-1-6-2.67-2.67-3.69-4.21-5.37-3.74-3-6-2.67c-2 .31-3.53 1.82-5.2 2.95s-4 1.9-5.6.69c-.9-.68-1.33-1.82-2.19-2.54-2.22-1.86-5.66.05-7.29 2.44-3.23 4.76-4.84 7.11-10.58 8.92-1.88.59-3.06.46-3.7-.11-1.25 2.89-.68 5.43 3.7 4.05 5.74-1.81 7.35-4.15 10.58-8.91 1.63-2.4 5.07-4.31 7.29-2.45.86.72 1.29 1.86 2.19 2.54 1.61 1.21 3.94.45 5.6-.68s3.21-2.65 5.2-2.95c2.25-.35 4.44 1 6 2.67s2.66 3.7 4.21 5.37 3.74 3 6 2.66 4.09-3 2.93-5a11.73 11.73 0 0 1 9.49 7.19 48.65 48.65 0 0 0 1.77 5.05 12 12 0 0 0 3.63 3.87c1.84 1.35 4.06 2.48 6.3 2.09s4.14-3 3.1-5c.72 1.09 2.25-.43 2.49-1.71a18.34 18.34 0 0 0 .18-5.23q-.05.65-.18 1.3z" />
      <path d="M776 330.82c0-.06 0-.1.05-.16 1.09-4.06-2-7.89-3.93-11.62a23.16 23.16 0 0 1-2.48-8.45 12 12 0 0 0-.12 1.58 23.23 23.23 0 0 0 2.6 10.81c1.36 2.55 3.21 5.15 3.88 7.84z" />
      <path d="M852.68 320.66c-1.55 2.65-4.1 4.79-4.81 7.78a8.68 8.68 0 0 0 0 3.83c.74-2.93 3.24-5.05 4.77-7.67a13 13 0 0 0 1.54-8.44 12.1 12.1 0 0 1-1.5 4.5z" />
    </g>
    <path
      d="M729.76 501.51a31.79 31.79 0 0 1 .61 3.35s15.8 37 17.8 39.19c.61.68 2.93 4 5.85 8.29l3.35 4.94c6 9 12.79 19.17 12.79 19.17L785 589.41s32.19 2.57 42.42-7.87c-1.24-.87-2-1.33-2-1.33l-4.4-3.42c-2.27-3.83-11-7.57-19.76-10.5-8.1.06-14.73.72-14.73.72l-2.1-5.55-2.2-5.79L771 526.25s-7.22-37.19-9.62-39-1.79-7.4-1.79-7.4 4.39-15.8 2.79-18 2.6-18.39 2.6-18.39a16.36 16.36 0 0 0-1.92-4.49l-30.87 58.68s-1.05 1.68-2.43 3.86z"
      opacity=".1"
    />
    <path
      d="M765.36 442.27s-4.2 16.19-2.6 18.39-2.8 18-2.8 18-.59 5.6 1.8 7.4 9.62 39 9.62 39l15.49 40.8s48.48-4.8 43.49 10.4-45 12-45 12l-14.8-13s-20-30.2-22-32.4-17.8-39.19-17.8-39.19-.8-7.4-4.2-11.2-.8-10.23-.8-10.23-4.2-48.36.2-54.16 34.8-3.21 39.4 14.19z"
      fill="#ee8e9e"
    />
    <path
      d="M740.57 411.87l-12.6 7.6s-3.6 12.2-6.4 13.8c0 0 25.2-14 44.19 18.19 0 0-.6-4.19 2-6.19s2-10.6 2-10.6a34.63 34.63 0 0 0 1.8-4.2c1.8-4.4-7.56-29.6-30.99-18.6z"
      opacity=".1"
    />
    <path
      d="M740.17 411.07l-12.6 7.6s-3.6 12.2-6.4 13.8c0 0 25.2-14 44.19 18.19 0 0-.6-4.19 2-6.19s2-10.6 2-10.6a34.63 34.63 0 0 0 1.8-4.2c1.84-4.4-7.6-29.6-30.99-18.6z"
      fill="#434175"
    />
    <ellipse cx="627.88" cy="721.41" rx="37.56" ry="39.87" fill="#fbd56f" />
    <ellipse cx="627.88" cy="721.41" rx="37.56" ry="39.87" opacity=".1" />
    <ellipse cx="634.36" cy="722.3" rx="37.56" ry="38.98" fill="#fbd56f" />
    <ellipse cx="90.14" cy="735.48" rx="46.39" ry="7.84" fill="#674f91" />
    <path
      d="M109.32 722.65c2-1.85 3.85-4 4.43-6.68s-.56-5.82-3.09-6.79c-2.84-1.09-5.88.88-8.18 2.87s-4.93 4.25-7.94 3.83a12.09 12.09 0 0 0 3.74-11.32 4.7 4.7 0 0 0-1-2.3c-1.57-1.68-4.43-1-6.32.37-6 4.22-7.67 12.37-7.7 19.7-.61-2.65-.1-5.4-.11-8.12s-.76-5.72-3-7.18a9.25 9.25 0 0 0-4.65-1.09c-2.7-.1-5.7.17-7.54 2.14-2.29 2.46-1.7 6.57.29 9.27s5 4.38 7.81 6.25a17.41 17.41 0 0 1 5.58 5.32 5.13 5.13 0 0 1 .41 1h16.91a47 47 0 0 0 10.36-7.27z"
      fill="#674f91"
    />
    <path
      d="M424.33 299.58l37.92-19 14 12.83 3.33 9.17 3.5 15.41-3.08 6.75-24.25 4.42s-12.92-.75-14.92.25-10.16 2.73-10.16 2.73l-6.34-15.61z"
      fill="#fbd56f"
    />
  </svg>
);
